module.exports = __webpack_public_path__ + "img/ico4.669fe7bd.png";